module.exports = __webpack_public_path__ + "static/img/Cameron-Guthrie.c3dc500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cameron-Guthrie.jpg
// module id = N44k
// module chunks = 0